<template>
  <v-container>
    <v-alert v-if="breakpoint === 'xs' || breakpoint === 'sm'" type="info" variant="tonal" class="mx-auto mb-4"
      max-width="400" density="compact">
      Use a larger screen for a better experience. This app is best viewed on a tablet or desktop.
    </v-alert>
    <v-card
      :class="['mx-auto', 'pa-2', 'card', { 'mt-8': breakpoint === 'xs' || breakpoint === 'sm', 'mt-16': breakpoint !== 'xs' && breakpoint !== 'sm' }]"
      max-width="400">
      <v-card-item>
        <v-card-title>
          New Account
        </v-card-title>
      </v-card-item>
      <!-- <v-card-text>
        We will periodically be opening access
      </v-card-text> -->
      <v-form @submit.prevent="onSubmit">
        <v-text-field :model-value="email" @update:model-value="onEmailInput" name="email" label="Email" type="text"
          placeholder="Email" variant="outlined" required :rules="emailRules" autofocus class="mx-2"></v-text-field>

        <v-text-field v-model="username" name="username" label="Username" type="text" placeholder="Username"
          variant="outlined" required :rules="usernameRules" class="mx-2"></v-text-field>

        <v-text-field v-model="first" name="first" label="First Name" type="text" placeholder="First Name"
          variant="outlined" required :rules="firstRules" class="mx-2"></v-text-field>

        <v-text-field v-model="last" name="last" label="Last Name" type="text" placeholder="Last Name"
          variant="outlined" class="mx-2"></v-text-field>

        <v-text-field v-model="password" name="password" label="Password" type="password" placeholder="Password"
          variant="outlined" required :rules="passwordRules" @keydown.enter="register" class="mx-2"></v-text-field>

        <v-text-field v-model="confirmPassword" name="confirmPassword" label="Confirm Password" type="password"
          placeholder="Confirm Password" variant="outlined" required :rules="confirmPasswordRules"
          @keydown.enter="register" class="mx-2"></v-text-field>

        <v-text-field
          v-if="signupCodesEnabled"
          v-model="code"
          name="signupCode"
          label="Signup Code"
          type="text"
          placeholder="Signup Code"
          variant="outlined"
          :rules="signupCodeRules"
          required
          @keydown.enter="register"
          class="mx-2"
        ></v-text-field>

        <v-checkbox v-model="terms" label="" required @keydown.enter="register">
          <template v-slot:label>
            I agree to the&nbsp;<a href="https://missionsquad.ai/privacy" target="_blank">terms and conditions</a>.
          </template>
        </v-checkbox>

      </v-form>
      <v-card-actions>
        <v-btn @click.stop.prevent="register" text="Register" :disabled="registerDisabled()" variant="outlined"></v-btn>
      </v-card-actions>
    </v-card>
    <!-- <div class="mx-auto mt-8 pa-2 access-text">
      <p>We're periodically opening access to new users. You can <router-link to="/request">request access by submitting your email address here</router-link>.</p>
    </div> -->
  </v-container>
</template>
<script lang="ts">
import { checkEmail, checkName, normalizeLowercaseInput } from '@/utils/general'
import { defaultDashboardPath } from '@/router/dashboardTabs'
import { Options, mixins } from 'vue-class-component'
import { mapGetters } from 'vuex'
import { useRouter } from 'vue-router'
import AnalyticsMixin from '@/mixins/AnalyticsMixin'

@Options({
  computed: {
    breakpoint(): string {
      return this.$vuetify.display.name
    },
    ...mapGetters(['authenticated', 'signupCodesEnabled'])
  },
  watch: {
    breakpoint(value: any) {
      // change layout
    },
    // authenticated(value: boolean) {
    //   if (value) {
        
    //   }
    // }
  }
})
export default class RegisterView extends mixins(AnalyticsMixin) {
  public breakpoint!: string
  public authenticated!: boolean
  public signupCodesEnabled!: boolean
  public email: string = ''
  public username: string = ''
  public first: string = ''
  public last: string = ''
  public password: string = ''
  public confirmPassword: string = ''
  public code: string = ''
  public terms: boolean | null = false
  public authFailureMessage: string = ''
  private router = useRouter()

  public emailRules = [
    (v: string) => !!v.trim() || 'Email is required',
    (v: string) => checkEmail(v.trim()) || 'Invalid email address.',
  ]

  public usernameRules = [
    (v: string) => !!v.trim() || 'Username is required',
    (v: string) => !checkEmail(v.trim()) || 'Username is not an email address.',
  ]

  public firstRules = [
    (v: string) => !!v || 'First name is required',
    (v: string) => checkName(v) || 'First name must be at least 2 characters long and only contain letters.',
  ]

  public passwordRules = [
    (v: string) => !!v || 'Password is required',
    (v: string) => (v && v.length >= 8) || 'Password must be at least 8 characters.',
  ]

  public confirmPasswordRules = [
    (v: string) => !!v || 'Confirm password is required',
    (v: string) => (v && v === this.password) || 'Passwords must match.',
  ]

  public signupCodeRules = [
    (v: string) => !this.signupCodesEnabled || !!v || 'Signup code is required',
  ]

  public async mounted() {
    this.trackComponentView('register_page');
    await this.$store.dispatch('fetchSignupCodesStatus');
    const params = new URLSearchParams(window.location.search);
    const qpCode = params.get('code');
    const qpEmail = params.get('email');
    if (qpCode) this.code = qpCode;
    if (qpEmail) this.email = normalizeLowercaseInput(qpEmail);
    await this.$store.dispatch('checkAuth')
  }

  public onSubmit() {
    console.log('?')
  }

  public onEmailInput(value: string) {
    this.email = normalizeLowercaseInput(value)
  }

  public registerDisabled() {
    const username = this.username.trim()
    const email = this.email.trim()
    const password = this.password.trim()
    const confirmPassword = this.confirmPassword.trim()
    const code = this.code.trim()
    if (
      username !== '' &&
      !checkEmail(username) &&
      password !== '' &&
      password === confirmPassword &&
      email !== '' &&
      checkEmail(email) &&
      this.terms &&
      (!this.signupCodesEnabled || code !== '')
    ) {
      return false
    } else {
      return true
    }
  }
  
  public async register() {
    this.trackFormInteraction('register_form', 'submit');
    try {
      // sign in here
      const username = this.username.trim()
      const email = normalizeLowercaseInput(this.email).trim()
      const first = this.first.trim()
      const last = this.last.trim()
      const password = this.password.trim()
      const confirmPassword = this.confirmPassword.trim()
      this.username = username
      this.email = email
      // const code = this.code.trim()
      if (username !== '' && !checkEmail(username) && first !== '' && password !== '' && password === confirmPassword && email !== '' && checkEmail(email) && this.terms) {
        const signupCode = this.signupCodesEnabled ? this.code.trim() : undefined
        const { success, message } = await this.$store.dispatch('register', { username, first, last, password, email, signupCode })
        if (success) {
          this.password = ''
          this.confirmPassword = ''
          this.trackConversion('signup_complete', 1, { method: 'email' });
          await this.router.push(defaultDashboardPath)
        } else {
          this.trackEvent('signup_failure', { reason: message });
        }
      }
    } catch (error: any) {
      this.trackEvent('signup_failure', { reason: error.message });
    }
  }
}
</script>
<style scoped lang="scss">
.card {
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.access-text {
  max-width: 400px;
}
</style>
